import { useEffect, useMemo, useState } from 'react';
import { apiRequest } from '../apiClient';
import { buildUiHelpers } from './sharedUi';

const STATUS_LABELS = { declined: 'Abgelehnt', unsubscribed: 'Abgemeldet', subscribed: 'Angemeldet', pending: 'Offen' };
const SOURCE_LABELS = { registration: 'Registrierung', profile: 'Profil', public_newsletter: 'Newsletter-Seite', account_popup: 'Popup im Konto' };

export default function AdminNewsletterContacts({ COLORS, th, td }) {
  const { Btn } = useMemo(() => buildUiHelpers({ COLORS, th }), [COLORS, th]);
  const [page, setPage] = useState({ items: [], total: 0, subscribed: 0 });
  const [offset, setOffset] = useState(0);
  const [status, setStatus] = useState('all');
  const [reload, setReload] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setLoading(true);
    apiRequest(`/admin/newsletter-contacts?offset=${offset}&status=${status}`).then(data => {
      if (active) { setPage(data); setError(''); }
    }).catch(err => { if (active) setError(err.message); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [offset, reload, status]);
  return <section style={{ marginTop: 24, paddingTop: 20, borderTop: `1px solid ${COLORS.border}` }}>
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 12, alignItems: 'center' }}>
      <h3 style={{ fontSize: 15 }}>Newsletter-Kontakte</h3>
      <label style={{ color: COLORS.muted, fontSize: 13 }}>Status{' '}
        <select value={status} onChange={event => { setStatus(event.target.value); setOffset(0); }} style={{ background: COLORS.card, color: COLORS.text, border: `1px solid ${COLORS.border}`, borderRadius: 6, padding: 8 }}>
          <option value="all">Alle</option>
          {Object.entries(STATUS_LABELS).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
        </select>
      </label>
      <Btn color="ghost" onClick={() => setReload(value => value + 1)} disabled={loading}>Aktualisieren</Btn>
    </div>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 18px', color: COLORS.muted, fontSize: 13, marginBottom: 12 }}>
      {Object.entries(STATUS_LABELS).map(([value, label]) => <span key={value}>{label}: {page.counts?.[value] ?? 0}</span>)}
    </div>
    {error && <p role="alert" style={{ color: COLORS.red }}>{error}</p>}
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead><tr>{['E-Mail', 'Status', 'Status seit', 'Einwilligung', 'Quelle'].map(label => <th key={label} style={th}>{label}</th>)}</tr></thead>
        <tbody>{page.items.map(contact => <tr key={contact.id}>
          <td style={td}>{contact.email || 'Adresse entfernt'}</td>
          <td style={td}>{STATUS_LABELS[contact.status] || contact.status}</td>
          <td style={td}>{(() => {
            const date = contact.status === 'declined' ? contact.declined_at : contact.status === 'unsubscribed' ? contact.unsubscribed_at : contact.status === 'subscribed' ? contact.confirmed_at : contact.requested_at;
            return date ? new Date(/[zZ]$|[+-]\d{2}:\d{2}$/.test(date) ? date : `${date}Z`).toLocaleString('de-DE') : '-';
          })()}</td>
          <td style={td}>{contact.consent_version || '-'}</td><td style={td}>{SOURCE_LABELS[contact.source] || contact.source}</td>
        </tr>)}</tbody>
      </table>
      {!page.items.length && <p style={{ color: COLORS.muted }}>{loading ? 'Wird geladen...' : 'Keine Newsletter-Kontakte vorhanden.'}</p>}
    </div>
    <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
      <Btn color="ghost" onClick={() => setOffset(value => Math.max(0, value - 50))} disabled={loading || offset === 0}>Zurück</Btn>
      <Btn color="ghost" onClick={() => setOffset(value => value + 50)} disabled={loading || offset + 50 >= page.total}>Weiter</Btn>
    </div>
  </section>;
}
